import "../webpack_path";
import React from "react";
import ReactDOM from "react-dom";
import { inferEnv } from "@glamcorner/core-cf-lib/lib/client/Hosting";
import { airbrake } from "../airbrake";
import ChoosePlanContainer from "./ChoosePlanContainer";

window["airbrake"] = airbrake;

airbrake.addFilter(function (notice: any) {
  notice.context.environment = inferEnv();
  return notice;
});

airbrake.call(() => {
  ReactDOM.render(<ChoosePlanContainer />, document.getElementById("root"));
});
